var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Tag from 'syf-component-library/ui/atoms/Tag/Tag';
import { spacing } from '../../../styles/theme';
export var StyledTag = styled(Tag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1px ", "px;\n"], ["\n  padding: 1px ", "px;\n"])), spacing.base);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map